import { Col } from '@repo/ui/components'
import type { CSSVariableBreakpointToken } from '@repo/ui/types'

interface ILandingLayoutProps {
  children: React.ReactNode
  footer?: React.ReactNode
  header?: React.ReactNode
  sidebar?: React.ReactNode
  subHeader?: React.ReactNode
  screenMaxWidth?: CSSVariableBreakpointToken
}

export const LandingLayout = (props: ILandingLayoutProps) => {
  const { children, footer, header, screenMaxWidth = 'md' } = props
  const screenMaxWidthClass = (
    {
      '5xs': 'max-w-screen-5xs',
      '4xs': 'max-w-screen-4xs',
      '3xs': 'max-w-screen-3xs',
      '2xs': 'max-w-screen-2xs',
      xs: 'max-w-screen-xs',
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      full: 'max-w-screen-full',
    } satisfies Record<CSSVariableBreakpointToken, string>
  )[screenMaxWidth]
  return (
    <Col className='min-h-screen bg-neutral-surface-light'>
      {header && (
        <header className='sticky top-0 w-full z-10 max-w-screen-md mx-auto'>
          {header}
        </header>
      )}

      <div
        className={`flex w-full flex-1 ${screenMaxWidthClass} mx-auto gap-md`}
      >
        <main className='flex-1 w-full p-md md:p-0'>{children}</main>
      </div>

      {footer && <footer>{footer}</footer>}
    </Col>
  )
}
